module.exports = __webpack_public_path__ + "static/media/cpp.ad5146ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/validations/images/cpp.png
// module id = 612
// module chunks = 146